import { IMAGE_ACCEPT } from '../../../utils/imageCompression';

// Deux inputs : `capture` force l'ouverture directe de l'appareil photo sur mobile
// (usage principal sur le terrain) mais empêche de choisir dans la galerie — d'où
// un second input sans `capture`, accessible via un simple lien discret.
function EquipmentPhotoSection({ imagePreview, onImageChange, onDeleteImage, disabled = false }) {
    const cameraFor = disabled ? undefined : 'equipment-image-camera';

    return (
        <div className="equip-photo-wrap">
            <input
                type="file"
                id="equipment-image-camera"
                accept={IMAGE_ACCEPT}
                capture="environment"
                onChange={onImageChange}
                disabled={disabled}
                style={{ display: 'none' }}
            />
            <input
                type="file"
                id="equipment-image-gallery"
                accept={IMAGE_ACCEPT}
                onChange={onImageChange}
                disabled={disabled}
                style={{ display: 'none' }}
            />
            {!imagePreview ? (
                <label
                    htmlFor={cameraFor}
                    className={`equip-photo-dropzone${disabled ? ' equip-photo-dropzone--disabled' : ''}`}
                    title={disabled ? 'Photo indisponible hors-ligne' : undefined}
                >
                    <span className="equip-photo-dropzone-icon">📷</span>
                    <span className="equip-photo-dropzone-text">
                        {disabled ? 'Photo indisponible hors-ligne' : 'Ajouter une photo'}
                    </span>
                </label>
            ) : (
                <div className="equip-photo-preview">
                    <img src={imagePreview} alt="Prévisualisation" />
                    <div className="equip-photo-actions">
                        <label htmlFor={cameraFor} className="equip-photo-change">Changer</label>
                        <button type="button" className="equip-photo-delete" onClick={onDeleteImage} disabled={disabled}>Supprimer</button>
                    </div>
                </div>
            )}
            {!disabled && (
                <label htmlFor="equipment-image-gallery" className="photo-gallery-link">
                    ou choisir depuis la galerie
                </label>
            )}
        </div>
    );
}

export default EquipmentPhotoSection;
